import Gudang from './gudang.route';

export default Gudang.map(route => ({
    ...route,
    meta: {
        ...route.meta,
        parent: 'Gudang'
    }
}));